/* Kairos — hız adımı 7, 29.09.2026. assets/product-global.js */
(function() {
    const content = document.querySelector(".product__content"), rating = document.querySelector(".spr-starrating");
    !content || !rating || (content.classList.contains("text-center") ? rating.style.justifyContent = "center" : content.classList.contains("text-right") ? rating.style.justifyContent = "flex-end" : content.classList.contains("text-left") && (rating.style.justifyContent = "flex-start"));
})(), document.addEventListener("DOMContentLoaded", function() {
    if (!document.getElementById("kairos-sticky-atc-v4-style")) {
        const stickyStyle = document.createElement("style");
        stickyStyle.id = "kairos-sticky-atc-v4-style", stickyStyle.textContent = `\n      [data-kairos-sticky-atc] .kairos-sticky-atc__image {\n        display: block;\n        object-fit: contain;\n        background: #fff;\n      }\n\n      @media screen and (max-width: 749px) {\n        [data-kairos-sticky-atc] .kairos-sticky-atc__summary {\n          display: flex !important;\n          align-items: center !important;\n          justify-content: flex-start !important;\n          flex: 0 0 46px !important;\n          width: 46px !important;\n          min-width: 46px !important;\n          max-width: 46px !important;\n          margin: 0 8px 0 0 !important;\n          padding: 0 !important;\n          overflow: visible !important;\n        }\n\n        [data-kairos-sticky-atc] .kairos-sticky-atc__image {\n          display: block !important;\n          visibility: visible !important;\n          opacity: 1 !important;\n          width: 46px !important;\n          height: 46px !important;\n          min-width: 46px !important;\n          max-width: 46px !important;\n          margin: 0 !important;\n          padding: 3px !important;\n          border: 1px solid #e8ddd2 !important;\n          border-radius: 8px !important;\n          object-fit: contain !important;\n          background: #fff !important;\n        }\n\n        [data-kairos-sticky-atc]\n        .kairos-sticky-atc__summary\n        .kairos-sticky-atc__text {\n          display: none !important;\n        }\n      }\n    `, 
        document.head.appendChild(stickyStyle);
    }
    document.querySelectorAll("[data-kairos-sticky-atc]").forEach(initKairosStickyBar);
    function initKairosStickyBar(bar) {
        const section = bar.closest(".main-product") || document.querySelector(".main-product");
        if (!section) return;
        const form = bar.querySelector("[data-kairos-sticky-form]"), variantInput = bar.querySelector("[data-kairos-variant-id]"), submitButton = bar.querySelector("[data-kairos-sticky-submit]"), priceEl = bar.querySelector("[data-kairos-sticky-price]"), imageRoot = bar.querySelector("[data-kairos-sticky-image]") || bar.querySelector(".kairos-sticky-atc__image"), variantsScript = bar.querySelector("[data-kairos-sticky-variants]"), stickySelects = Array.from(bar.querySelectorAll("[data-kairos-option-index]")).sort(function(a, b) {
            return Number(a.dataset.kairosOptionIndex) - Number(b.dataset.kairosOptionIndex);
        });
        if (!form || !variantInput || !submitButton || !variantsScript) return;
        let variants = [];
        try {
            variants = JSON.parse(variantsScript.textContent || "[]");
        } catch (error) {
            console.error("Kairos varyant JSON hatası:", error);
            return;
        }
        if (!variants.length) return;
        let preferredOptions = [], syncing = !1, pending = null, token = 0, observer = null, lastIntentIndex = -1, lastIntentAt = 0;
        let imageVariantId = null, imageTimers = [], imageRetryUntil = 0;
        let cartBusy = false;
        function normalize(value) {
            return String(value || "").toLocaleLowerCase("tr-TR").replace(/ı/g, "i").replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ş/g, "s").replace(/ö/g, "o").replace(/ç/g, "c").replace(/\s+/g, " ").trim();
        }
        function same(a, b) {
            return String(a ?? "") === String(b ?? "");
        }
        function sameOptions(a, b) {
            return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every(function(value, index) {
                return same(value, b[index]);
            });
        }
        function variantById(id) {
            return variants.find(function(variant) {
                return Number(variant.id) === Number(id);
            }) || null;
        }
        function variantByOptions(options) {
            return variants.find(function(variant) {
                return variant.options.every(function(value, index) {
                    return same(value, options[index]);
                });
            }) || null;
        }
        function bestVariant(options, changedIndex) {
            const exact = variantByOptions(options);
            return exact || variants.filter(function(variant) {
                return changedIndex < 0 || same(variant.options[changedIndex], options[changedIndex]);
            }).map(function(variant) {
                let score = variant.available ? .25 : 0;
                return variant.options.forEach(function(value, index) {
                    same(value, options[index]) && (score += index === changedIndex ? 10 : 1);
                }), {
                    variant: variant,
                    score: score
                };
            }).sort(function(a, b) {
                return b.score - a.score;
            })[0]?.variant || null;
        }
        function money(cents) {
            return (Number(cents || 0) / 100).toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) + " ₺";
        }
        function mainForm() {
            return section.querySelector("product-form form") || section.querySelector('form[action*="/cart/add"]');
        }
        function mainVariantInput() {
            const currentForm = mainForm();
            return currentForm ? currentForm.querySelector('input[name="id"]') : null;
        }
        function mainAddButton() {
            return section.querySelector('product-form button[name="add"]') || section.querySelector(".product-selector__submit");
        }
        function optionGroups() {
            const controls = Array.from(section.querySelectorAll('select[name^="options["], input[type="radio"][name^="options["]')).filter(function(control) {
                return !bar.contains(control);
            }), names = [];
            return controls.forEach(function(control) {
                control.name && !names.includes(control.name) && names.push(control.name);
            }), names.map(function(name) {
                const items = controls.filter(function(control) {
                    return control.name === name;
                });
                return {
                    name: name,
                    selects: items.filter(function(item) {
                        return item.tagName === "SELECT";
                    }),
                    radios: items.filter(function(item) {
                        return item.tagName === "INPUT" && item.type === "radio";
                    })
                };
            });
        }
        function groupValue(group) {
            const checked = group.radios.find(function(radio) {
                return radio.checked;
            });
            if (checked) return checked.value;
            const nonEmptySelect = group.selects.find(function(select) {
                return select.value;
            });
            return nonEmptySelect ? nonEmptySelect.value : "";
        }
        function mainOptions() {
            return optionGroups().map(groupValue);
        }
        function optionIndexForControl(control) {
            return optionGroups().findIndex(function(group) {
                return group.name === control.name;
            });
        }
        function optionIndexForName(name) {
            const key = normalize(name);
            return optionGroups().findIndex(function(group) {
                return normalize(group.name).includes(key);
            });
        }
        function colorIndex() {
            const groups = optionGroups();
            for (let index = 0; index < variants[0].options.length; index += 1) {
                const values = variants.map(function(variant) {
                    return variant.options[index];
                }).join(" "), text = normalize((groups[index]?.name || "") + " " + values);
                if (text.includes("renk") || text.includes("maden") || text.includes("altin") || text.includes("color") || text.includes("tone") || text.includes("sari") || text.includes("rose") || text.includes("beyaz") || text.includes("yellow") || text.includes("white")) return index;
            }
            return -1;
        }
        function currentMainVariant() {
            const options = mainOptions(), byControls = variantByOptions(options);
            if (byControls) return byControls;
            const hidden = mainVariantInput(), byHidden = hidden ? variantById(hidden.value) : null;
            return byHidden || variantById(new URL(window.location.href).searchParams.get("variant"));
        }
        function stickyOptions() {
            const result = [];
            return stickySelects.forEach(function(select) {
                result[Number(select.dataset.kairosOptionIndex)] = select.value;
            }), result;
        }
        function stickyVariant() {
            return variantByOptions(stickyOptions());
        }
        function cleanImageUrl(url) {
            if (!url) return "";
            let result = String(url).trim();
            return result.indexOf("//") === 0 && (result = "https:" + result), result;
        }
        function variantImage(variant) {
            if (!variant) return "";
            const featuredImage = variant.featured_image, featuredMedia = variant.featured_media, variantImageValue = variant.image;
            return typeof featuredImage == "string" ? cleanImageUrl(featuredImage) : featuredImage?.src ? cleanImageUrl(featuredImage.src) : featuredImage?.url ? cleanImageUrl(featuredImage.url) : featuredMedia?.preview_image?.src ? cleanImageUrl(featuredMedia.preview_image.src) : featuredMedia?.preview_image?.url ? cleanImageUrl(featuredMedia.preview_image.url) : featuredMedia?.src ? cleanImageUrl(featuredMedia.src) : featuredMedia?.url ? cleanImageUrl(featuredMedia.url) : typeof variantImageValue == "string" ? cleanImageUrl(variantImageValue) : variantImageValue?.src ? cleanImageUrl(variantImageValue.src) : variantImageValue?.url ? cleanImageUrl(variantImageValue.url) : "";
        }
        function cssEscape(value) {
            const stringValue = String(value ?? "");
            return window.CSS && typeof window.CSS.escape == "function" ? window.CSS.escape(stringValue) : stringValue.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, "\\$1");
        }
        function sourceFromImage(image) {
            return image ? cleanImageUrl(image.currentSrc || image.getAttribute("src") || image.getAttribute("data-src") || "") : "";
        }
        function selectorImageForVariant(variant) {
            if (!variant?.options?.length) return "";
            for (let index = 0; index < variant.options.length; index += 1) {
                const value = variant.options[index], escapedValue = cssEscape(value), image = section.querySelector('[data-kairos-selector-value="' + escapedValue + '"] img, [data-kairos-stone="' + escapedValue + '"] img, [data-kairos-letter="' + escapedValue + '"] img'), source = sourceFromImage(image);
                if (source) return source;
            }
            return "";
        }
        function mediaImageForVariant(variant) {
            if (!variant) return "";
            const mediaIds = [ variant.featured_media?.id, variant.featured_image?.id, variant.image?.id ].filter(Boolean);
            for (const mediaId of mediaIds) {
                const escapedId = cssEscape(mediaId), image = section.querySelector('.product__media [data-media-id="' + escapedId + '"] img, .product__media [data-media-id$="-' + escapedId + '"] img'), source = sourceFromImage(image);
                if (source) return source;
            }
            return "";
        }
        function activeMainMediaImage() {
            const selectors = [ ".product__media .swiper-slide[data-selected] .media:not(.media--thumb) img", ".product__media .swiper-slide.is-active .media:not(.media--thumb) img", ".product__media .swiper-slide.swiper-slide-active .media:not(.media--thumb) img", ".product__media .product__gallery-opener.is-active img", ".product__media .media:not(.media--thumb) img" ];
            for (const selector of selectors) {
                const source = sourceFromImage(section.querySelector(selector));
                if (source) return source;
            }
            return "";
        }
        function ensureStickyImage() {
            let root = bar.querySelector("[data-kairos-sticky-image]") || bar.querySelector(".kairos-sticky-atc__image") || imageRoot, image = null;
            if (root?.tagName === "IMG" ? image = root : root && (image = root.querySelector("img")), 
            !image) {
                const summary = bar.querySelector(".kairos-sticky-atc__summary");
                if (!summary) return null;
                image = document.createElement("img"), image.className = "kairos-sticky-atc__image", 
                image.alt = "", summary.prepend(image);
            }
            if (!image.hasAttribute("data-kairos-sticky-image")) {
                image.setAttribute("data-kairos-sticky-image", "");
            }
            if (image.loading !== "eager") image.loading = "eager";
            if (image.decoding !== "async") image.decoding = "async";
            return image;
        }
        function setStickyImageSource(image, url, variant) {
            const cleanUrl = cleanImageUrl(url);
            if (!image || !cleanUrl) return false;
            const picture = image.closest("picture");
            const sources = picture ? Array.from(picture.querySelectorAll("source")) : [];
            sources.push(image);
            sources.forEach(function(source) {
                ["srcset", "data-srcset", "sizes"].forEach(function(attribute) {
                    if (source.hasAttribute(attribute)) source.removeAttribute(attribute);
                });
            });
            if (image.getAttribute("src") !== cleanUrl) image.setAttribute("src", cleanUrl);
            if (image.getAttribute("data-src") !== cleanUrl) image.setAttribute("data-src", cleanUrl);
            const alt = variant?.title || variant?.name || image.alt || "";
            if (image.alt !== alt) image.alt = alt;
            return true;
        }
        function updateStickyImage(variant, allowMainMediaFallback) {
            if (!variant) return;
            const image = ensureStickyImage();
            if (!image) return;
            const directUrl = variantImage(variant) || mediaImageForVariant(variant) || selectorImageForVariant(variant);
            if (directUrl) {
                setStickyImageSource(image, directUrl, variant);
                return;
            }
            if (allowMainMediaFallback !== !1) {
                const mainMediaUrl = activeMainMediaImage();
                mainMediaUrl && setStickyImageSource(image, mainMediaUrl, variant);
            }
        }
        function cancelImageRetries() {
            imageTimers.forEach(function(timer) { window.clearTimeout(timer); });
            imageTimers = [];
        }
        function queueStickyImageUpdate(variant) {
            const id = String(variant.id);
            if (id === imageVariantId) {
                // Aynı varyant için yeni zamanlayıcı açma. Geç gelen galeri görselini
                // kontrollü yedek kontrolde yakala; aynı URL yeniden yazılmaz.
                updateStickyImage(variant, Date.now() >= imageRetryUntil);
                return;
            }
            cancelImageRetries();
            imageVariantId = id;
            imageRetryUntil = Date.now() + 520;
            updateStickyImage(variant, false);
            imageTimers = [40, 120, 280, 520].map(function(delay) {
                return window.setTimeout(function() {
                    if (bar.isConnected && imageVariantId === id) {
                        updateStickyImage(variant, true);
                    }
                }, delay);
            });
        }
        function updateSticky(variant, savePreference) {
            if (!variant) {
                if (!cartBusy) {
                    if (!submitButton.disabled) submitButton.disabled = true;
                    if (submitButton.textContent !== "Seçenek Yok") submitButton.textContent = "Seçenek Yok";
                }
                return;
            }
            if (savePreference !== false) preferredOptions = variant.options.slice();
            if (variantInput.value !== String(variant.id)) variantInput.value = variant.id;
            variant.options.forEach(function(value, index) {
                const select = stickySelects.find(function(item) {
                    return Number(item.dataset.kairosOptionIndex) === index;
                });
                if (!select || same(select.value, value)) return;
                const option = Array.from(select.options).find(function(item) {
                    return same(item.value, value);
                });
                if (option) select.value = option.value;
            });
            if (priceEl && variant.price != null) {
                const price = money(variant.price);
                if (priceEl.textContent !== price) priceEl.textContent = price;
            }
            queueStickyImageUpdate(variant);
            // Arka plan kontrolü, devam eden sepete ekleme durumunu bozmasın.
            if (!cartBusy) {
                const disabled = !variant.available;
                const label = variant.available ? "Sepete Ekle" : "Tükendi";
                if (submitButton.disabled !== disabled) submitButton.disabled = disabled;
                if (submitButton.textContent !== label) submitButton.textContent = label;
            }
        }
        function setGroup(group, value) {
            let dispatchControl = null;
            return group.selects.forEach(function(select) {
                const option = Array.from(select.options).find(function(item) {
                    return same(item.value, value);
                });
                option && (select.value = option.value, dispatchControl || (dispatchControl = select));
            }), group.radios.forEach(function(radio) {
                radio.checked = same(radio.value, value), radio.checked && (dispatchControl = radio);
            }), dispatchControl;
        }
        function setHiddenVariant(id) {
            const input = mainVariantInput();
            input && (input.value = id, input.setAttribute("value", id));
        }
        function setVariantUrl(id) {
            const url = new URL(window.location.href);
            url.searchParams.set("variant", id), window.history.replaceState({}, "", url.toString());
        }
        function applyMainVariant(variant, changedIndex) {
            if (!variant || syncing) return;
            syncing = !0, preferredOptions = variant.options.slice();
            const localToken = ++token;
            function apply(dispatchEvent) {
                if (localToken !== token) return;
                const groups = optionGroups(), controls = [];
                if (groups.forEach(function(group, index) {
                    controls[index] = setGroup(group, variant.options[index]);
                }), setHiddenVariant(variant.id), setVariantUrl(variant.id), !dispatchEvent) return;
                let dispatchIndex = changedIndex;
                const cIndex = colorIndex();
                if (changedIndex === cIndex && controls.length > 1) {
                    const nonColorIndexes = controls.map(function(control2, index) {
                        return control2 && index !== cIndex ? index : -1;
                    }).filter(function(index) {
                        return index > -1;
                    });
                    nonColorIndexes.length && (dispatchIndex = nonColorIndexes[nonColorIndexes.length - 1]);
                }
                const control = controls[dispatchIndex] || controls[changedIndex] || controls.find(Boolean);
                control && (control.dispatchEvent(new Event("input", {
                    bubbles: !0
                })), control.dispatchEvent(new Event("change", {
                    bubbles: !0
                })));
            }
            apply(!0), setTimeout(function() {
                apply(!1);
            }, 60), setTimeout(function() {
                apply(!0);
            }, 180), setTimeout(function() {
                localToken === token && (setHiddenVariant(variant.id), setVariantUrl(variant.id), 
                updateSticky(variant, !0), syncing = !1);
            }, 380);
        }
        function queueIntent(index, value) {
            if (syncing || index < 0) return;
            const sequence = ++token;
            lastIntentIndex = index, lastIntentAt = Date.now(), pending = {
                sequence: sequence,
                index: index,
                value: value,
                base: preferredOptions.slice()
            }, [ 0, 80, 220 ].forEach(function(delay) {
                setTimeout(function() {
                    if (!pending || pending.sequence !== sequence || syncing) return;
                    const current = mainOptions(), desired = pending.base.length ? pending.base.slice() : current.slice();
                    for (;desired.length < variants[0].options.length; ) desired.push("");
                    desired[index] = pending.value || current[index];
                    const selected = bestVariant(desired, index);
                    if (!selected) return;
                    pending = null, updateSticky(selected, !0);
                    const active = currentMainVariant();
                    (!active || Number(active.id) !== Number(selected.id) || !sameOptions(mainOptions(), selected.options)) && applyMainVariant(selected, index);
                }, delay);
            });
        }
        function reconcile() {
            if (syncing || pending) return;
            const current = mainOptions(), byControls = variantByOptions(current);
            if (!preferredOptions.length) {
                const initial2 = byControls || currentMainVariant();
                initial2 && updateSticky(initial2, !0);
                return;
            }
            if (current.length === preferredOptions.length && current.every(Boolean)) {
                const changed = [];
                if (current.forEach(function(value, index) {
                    same(value, preferredOptions[index]) || changed.push(index);
                }), !changed.length) {
                    byControls && updateSticky(byControls, !1);
                    return;
                }
                if (changed.length === 1) {
                    const index = changed[0], cIndex2 = colorIndex();
                    if (lastIntentIndex === cIndex2 && index !== cIndex2 && Date.now() - lastIntentAt < 1400) {
                        const preserved = bestVariant(preferredOptions.slice(), cIndex2);
                        preserved && (updateSticky(preserved, !0), applyMainVariant(preserved, cIndex2));
                        return;
                    }
                    const desired = preferredOptions.slice();
                    desired[index] = current[index];
                    const selected = bestVariant(desired, index);
                    selected && (updateSticky(selected, !0), (!byControls || Number(byControls.id) !== Number(selected.id)) && applyMainVariant(selected, index));
                    return;
                }
                const cIndex = colorIndex();
                if (cIndex > -1 && changed.includes(cIndex)) {
                    const desired = preferredOptions.slice();
                    desired[cIndex] = current[cIndex];
                    const selected = bestVariant(desired, cIndex);
                    if (selected) {
                        updateSticky(selected, !0), applyMainVariant(selected, cIndex);
                        return;
                    }
                }
            }
            const fallback = byControls || currentMainVariant();
            fallback && updateSticky(fallback, !0);
        }
        stickySelects.forEach(function(select) {
            select.addEventListener("change", function() {
                const selected = stickyVariant();
                if (!selected) {
                    updateSticky(null, false);
                    return;
                }
                const index = Number(select.dataset.kairosOptionIndex);
                updateSticky(selected, !0), applyMainVariant(selected, index);
            });
        }), section.addEventListener("change", function(event) {
            if (syncing || event.target.closest("[data-kairos-sticky-atc]")) return;
            const target = event.target;
            if (target.matches('select[name^="options["], input[type="radio"][name^="options["]')) {
                if (target.type === "radio" && !target.checked) return;
                queueIntent(optionIndexForControl(target), target.value);
            } else setTimeout(reconcile, 60), setTimeout(reconcile, 200);
        }, !0), section.addEventListener("click", function(event) {
            if (syncing || event.target.closest("[data-kairos-sticky-atc]")) return;
            if (event.target.closest("[data-kairos-tone]")) {
                const index = colorIndex();
                setTimeout(function() {
                    const values = mainOptions();
                    queueIntent(index, values[index]);
                }, 0);
                return;
            }
            const selectorButton = event.target.closest("[data-kairos-selector-value]");
            if (selectorButton) {
                const root = selectorButton.closest("[data-kairos-premium-selector]");
                queueIntent(root ? optionIndexForName(root.getAttribute("data-option-name")) : -1, selectorButton.getAttribute("data-kairos-selector-value"));
            }
        }, !0);
        // Kullanıcı seçimleri mevcut change/click olaylarıyla hemen işlenir.
        // Bu aralık yalnızca temanın olay göndermeden yaptığı değişiklikler içindir.
        let watcher = null;
        function startWatcher() {
            if (watcher !== null) return;
            watcher = window.setInterval(function() {
                if (!bar.isConnected) {
                    stopWatcher();
                    return;
                }
                if (!document.hidden) reconcile();
            }, 1000);
        }
        function stopWatcher() {
            window.clearInterval(watcher);
            watcher = null;
            cancelImageRetries();
        }
        startWatcher();
        function showSticky(show) {
            if (bar.classList.contains("is-visible") !== show) {
                bar.classList.toggle("is-visible", show);
                if (show) reconcile();
            }
        }
        const addButton = mainAddButton();
        "IntersectionObserver" in window && addButton ? (observer = new IntersectionObserver(function(entries) {
            showSticky(!entries[0].isIntersecting && window.scrollY > 260);
        }, {
            threshold: .1
        }), observer.observe(addButton)) : window.addEventListener("scroll", function() {
            showSticky(window.scrollY > 520);
        }, {
            passive: !0
        }), form.addEventListener("submit", async function(event) {
            event.preventDefault();
            if (cartBusy) return;
            const selected = stickyVariant() || variantById(variantInput.value) || currentMainVariant();
            if (!selected || !selected.available) {
                submitButton.disabled = !0, submitButton.textContent = "Seçenek Yok";
                return;
            }
            cartBusy = true;
            variantInput.value = selected.id, submitButton.disabled = !0, submitButton.textContent = "Ekleniyor...";
            try {
                const data = new FormData(form);
                if (data.set("id", selected.id), !(await fetch("/cart/add.js", {
                    method: "POST",
                    body: data,
                    headers: {
                        Accept: "application/json"
                    }
                })).ok) throw new Error("Sepete eklenemedi");
                submitButton.textContent = "Sepete Eklendi", document.dispatchEvent(new CustomEvent("cart:refresh")), 
                document.dispatchEvent(new CustomEvent("cart:updated")), window.dispatchEvent(new CustomEvent("cart:refresh")), 
                setTimeout(function() {
                    cartBusy = false;
                    updateSticky(stickyVariant() || currentMainVariant(), false);
                }, 1500);
            } catch (error) {
                console.error("Kairos sticky sepet hatası:", error), submitButton.textContent = "Tekrar Dene", 
                setTimeout(function() {
                    cartBusy = false;
                    updateSticky(stickyVariant() || currentMainVariant(), false);
                }, 1800);
            }
        });
        const initial = currentMainVariant() || variantById(variantInput.value) || variants[0];
        initial && updateSticky(initial, !0), window.addEventListener("pageshow", function() {
            startWatcher();
            if (observer && addButton) observer.observe(addButton);
            setTimeout(reconcile, 0), setTimeout(reconcile, 200);
        }), window.addEventListener("popstate", function() {
            setTimeout(reconcile, 0), setTimeout(reconcile, 200);
        }), window.addEventListener("pagehide", function() {
            stopWatcher();
            if (observer) observer.disconnect();
        });
    }
});
